import * as React from "react";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Link } from "react-router-dom";


export default function FavoriteLinkCard({ link, linkText, title, children, disableNewTab }) {
  return (
    <Card sx={{ minWidth: 275, boxShadow: "0 4px 8px rgba(0, 0, 0, 0.8)" }}>
      <CardContent>
        <Typography sx={{ fontSize: 11 }} color="text.secondary" gutterBottom>
          Карта избранных ссылок
        </Typography>
        <Typography variant="h5" component="div">
          {title}
        </Typography>
        <Typography variant="body2">{children}</Typography>
      </CardContent>
      <CardActions>
        <Button size="small" component={Link} to={link} target={disableNewTab ? "_self" : "_blank"}>
          {linkText}
        </Button>
      </CardActions>
    </Card>
  );
}
